import { makeSelectors } from '@utils/css';

const wrapper = "_35swxeo7q0";
const icon = "_35sioyqdzh";
makeSelectors({
  wrapper,
  icon
});

export { icon, wrapper };
import "./_state-box.style.linaria.module.css";
//# sourceMappingURL=_state-box.style.js.map
